import React from 'react';
import { Link } from 'react-router-dom';
import fotoProfilo from './foto-profilo.jpeg'; 

function About() {
  // Lista delle skill per generare i badge
  const skills = ["React", "WordPress", "JavaScript ES6+", "CSS3 / Sass", "WooCommerce", "SEO Basics", "UI/UX Design"];

  return (
    <>
      <div className="page-title-container">
        <h1>Chi Sono</h1>
      </div>

      <div className="about-container-v2">
        
        {/* FOTO */}
        <div className="about-visual">
          <img
            src={fotoProfilo}
            alt="Giovanni Rampazzo - Web Developer"
            className="profile-photo"
          />
        </div>

        {/* TESTO */}
        <section className="about-content-v2">
          
          {/* SEZIONE 1: Testo scelto (Opzione 2) */}
          <div className="text-block-v2">
            <h3>Design & Performance</h3>
            <p>
              Sviluppo soluzioni web dove il design incontra la funzionalità. Grazie al mio background artistico, 
              ho un approccio allo sviluppo attento alla User Experience (UX) e alla User Interface (UI). 
              Trasformo le esigenze del cliente in applicazioni performanti, senza mai sacrificare l'impatto visivo.
            </p>
          </div>

          {/* SEZIONE 2: Le Competenze (Visuali) */}
          <div className="text-block-v2">
            <h3>Il mio Toolkit</h3>
            <p style={{marginBottom: '15px'}}>
              Scelgo lo strumento migliore per il progetto, non quello che va di moda. 
              Dalla landing page veloce alla web app complessa:
            </p>
            <div className="skills-cloud">
              {skills.map((skill, index) => (
                <span key={index} className="tech-label">{skill}</span>
              ))}
            </div>
          </div>

          {/* SEZIONE 3: Il Vantaggio (Evidenziato) */}
          <div className="highlight-box">
            <h3>⚡ Perché un Freelance?</h3>
            <p>
              Lavorare con me significa eliminare i costi di struttura di un'agenzia e parlare direttamente 
              con chi scrive il codice.
            </p>
            <ul style={{marginTop: '15px', listStyle: 'none'}}>
              <li>✅ <strong>Zero intermediari:</strong> comunicazione tecnica diretta.</li>
              <li>✅ <strong>Budget ottimizzato:</strong> paghi la qualità, non l'ufficio.</li>
              <li>✅ <strong>Assistenza dedicata:</strong> un unico referente per ogni necessità.</li>
            </ul>
          </div>

          <div className="cta-group" style={{marginTop: '40px'}}>
             <Link to="/contact" className="btn-primary">Parlami del tuo progetto</Link>
          </div>
        </section>
      </div>
    </>
  );
}

export default About;